import { render, staticRenderFns } from "./Dashboard.view.vue?vue&type=template&id=6d9c5334&scoped=true"
import script from "./Dashboard.view.vue?vue&type=script&lang=js"
export * from "./Dashboard.view.vue?vue&type=script&lang=js"
import style0 from "./Dashboard.view.vue?vue&type=style&index=0&id=6d9c5334&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9c5334",
  null
  
)

export default component.exports